// extracted by mini-css-extract-plugin
export var highlightFade = "_1u-4";
export var highlighted = "_1u-3";
export var table = "_1u-1";
export var tableContainer = "_1u-0";
export var totalsRow = "_1u-2";